import * as React from 'react'

import { GridCentered } from '~ui/components/layout/Box'
import { Text } from '~ui/components/typography/Text/Text'
import { TGridPlacementProps } from '~ui/utils/gridUtils'

type TGridProps = TGridPlacementProps & Pick<PropsOf<typeof GridCentered>, 'minHeight' | 'padding'>

type TProps = NoChildren &
  TGridProps & {
    /**
     * message to render
     */
    message: React.ReactNode
  }

/**
 * Container with formatted text to show to the customers.
 */
export const CustomerMessage: React.FC<TProps> = ({ message, ...gridProps }) => {
  return (
    <GridCentered {...gridProps}>
      <Text fontSize={`l24`} contrast={`low`} fontStyle={`bold`} textAlign={`center`}>
        {message}
      </Text>
    </GridCentered>
  )
}
